/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import React, { useCallback, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Stream from './components/stream.component';
import { extendTheme } from '@chakra-ui/react';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import react from 'react';
import TermsOfUse from './components/terms.use.component';
import Privacy from './components/privacy.component';
import Constants from './constants';
import { getAssociatedTokenAddress } from '@solana/spl-token';
import { getAccountInfo, MINT_ADDRESS } from './api/qdot';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';
require('@solana/wallet-adapter-react-ui/styles.css');

export const ApplicationContext = react.createContext({ gallery: false });

export const customTheme = extendTheme({
  fonts: {
    body: `-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif`,
  },
  styles: {
    global: ({ colorMode }) => {
      return {
        body: {
          bg: 'gray.800',
          borderColor: 'transparent',
          padding: '0px',
          margin: '0px',
          width: '100%',
          height: '100%',
        },
        html: {
          padding: '0px',
          margin: '0px',
          width: '100%',
          height: '100%',
        },
      };
    },
  },
});

function App() {
  const [accountBalance, cacheAccountBalance] = useState(null);
  const [associatedTokenAddress, cacheAssociatedTokenAddress] = useState(null);
  const [accountExists, cacheAccountExists] = useState(false);

  const [solBalance, cacheSolBalance] = useState(null);
  const { connection } = useConnection();
  const { publicKey } = useWallet();

  const initilizeFinancials = useCallback(() => {
    if (publicKey !== null) {
      getAssociatedTokenAddress(MINT_ADDRESS, publicKey)
        .then(tokenAddr => {
          cacheAssociatedTokenAddress(tokenAddr.toBase58());
          return tokenAddr;
        })
        .then(tokenAddr =>
          getAccountInfo(connection, tokenAddr)
            .then(accountInfo => {
              cacheAccountExists(true);
              return accountInfo;
            })
            .then(accountInfo => {
              cacheAccountBalance(accountInfo.amount.toString());
            })
        )
        .catch(error => {
          const { message } = error;
          cacheAccountExists(!(message === 'TokenAccountNotFoundError'));
        });

      connection
        .getBalance(publicKey)
        .then(sols => {
          cacheSolBalance(sols / LAMPORTS_PER_SOL);
        })
        .catch(_err => {});
    }
  }, [publicKey]);

  useEffect(initilizeFinancials, [publicKey]);

  return (
    <ApplicationContext.Provider value="">
      <Routes>
        <Route
          index
          element={
            <Stream
              solBalance={solBalance}
              accountExists={accountExists}
              accountBalance={accountBalance}
              associatedTokenAddress={associatedTokenAddress}
            />
          }
        />
        <Route
          exact
          path="stream.view/:queue_address"
          element={
            <Stream
              solBalance={solBalance}
              accountExists={accountExists}
              accountBalance={accountBalance}
              associatedTokenAddress={associatedTokenAddress}
            />
          }
        />
        <Route exact path="privacy.view" element={<Privacy />} />
        <Route exact path="termsofuse.view" element={<TermsOfUse />} />
      </Routes>
    </ApplicationContext.Provider>
  );
}

export default App;
